import {Base, model, belongsTo, endpoint, getFrom} from '@scoutgg/ftw/source/lib/model'

@model('Lineup')
@endpoint('lineups', {root: '/api'})
@belongsTo('player')
@belongsTo('match')
@belongsTo('team')
@belongsTo('rider', 'Player')
@belongsTo('trainer', 'Player')
@getFrom('match', ['season'])
@getFrom('player', ['formalName', 'position'])
export class Lineup extends Base {
  get subIn() {
    return this.events.find(e => e.name === 'substitution_0')
  }
  get subOut() {
    return this.events.find(e => e.name === 'substitution_1')
  }
  get isOn() {
    if(this.match.sport !== 'football') return this.advancedIsOn()
    return (!this.isBench || this.subIn) && !this.subOut
  }
  get opponent() {
    return this.team === this.match.homeTeam
      ? this.match.awayTeam
      : this.match.homeTeam
  }
  get events() {
    return ((this.match && this.match.events) || [])
      .filter(e => e.player === this.player)
      .filter(e => !e.batch || !this.batch || e.batch === this.batch)
  }
  advancedIsOn(time) {
    var subIn = this.events
      .filter(e => time == null || e.seconds < time)
      .filter(e => e.name === 'substitution_0')
      .length + !this.isBench
    var subOut = this.events
      .filter(e => time == null || e.seconds < time)
      .filter(e => e.name === 'substitution_1')
      .length
    return subIn > subOut
  }

  get isBench() {
    return this.status === 'bench'
  }
  set isBench(v) {
    if(v) this.status = 'bench'
    if((v === false && !this.status) || this.status === 'bench') {
      this.status = 'confirmed'
    }
  }
  get participating() {
    return !this.status || ~['confirmed', 'bench', 'expected', 'possible'].indexOf(this.status)
  }
  get economyRate() {
    if(!this.stats) return 0
    const ret = ((this.stats.concededRun) / (this.stats.over || Infinity))
    if(ret) return ret.toFixed(2)
    return 0
  }
  get strikeRate() {
    if(!this.stats) return 0
    const ret = (((this.stats.run) / (this.stats.ball || Infinity)) * 100)
    if(ret) return ret.toFixed(2)
    return 0
  }

  toJSON() {
    const ret = {
      match: this.matchId,
      team: this.teamId,
      player: this.playerId,
      status: this.status,
    }
    if(this._id && !(this._id < 0)) ret._id = this._id
    if(this.batch) ret.batch = this.batch
    if(this.isBench) ret.isBench = true
    return ret
  }
}
